import React from "react";

export default function Footer() {
    return (
        <div className="footer">
            <br />
            <a href="https://github.com/jainam03/weather-react-app" target="blank" >
                <i className="fa fa-github fa-2x " id="icon"></i>
            </a>
        </div>
    )
}